import React from "react";
import { Theme, useTheme, css } from "@emotion/react";

type Props = {
    children: React.ReactNode
    showButton?: boolean,
};

const ButtonsContainer: React.FC<Props> = ({ children, showButton = true }) => {
    const theme: Theme = useTheme();

    const style = css`
        position: absolute;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        bottom: 61px;
        padding: 0 20px;
        gap: 24px;
        opacity: ${showButton ? 1 : 0};
        transition: opacity 1.1s ease-in-out;

        ${theme.breakpoints.up("5xl")} {
            bottom: 202px;
            gap: 38px;
        }

        ${theme.breakpoints.between("3xl", "4xl")} {
            bottom: 97.5px;
            gap: 38px;
        }

        ${theme.breakpoints.only("xl")} {
            bottom: 81px;
            gap: 24px;
        }

        ${theme.breakpoints.only("lg")} {
            bottom: 73px;
            gap: 20px;
        }

        ${theme.breakpoints.only("md")} {
            bottom: 90px;
            gap: 23px;
        }

        ${theme.breakpoints.only("sm")} {
            bottom: 79.78px;
            gap: 18.25px;
        }

        ${theme.breakpoints.down("xs")} {
            bottom: 57.78px;
            gap: 12.08px;
        }
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
}

export default ButtonsContainer;
